/**
 * KnowledgeTag Component — HMVMReviewer Design System Phase 1
 * 
 * Display knowledge base reference tags (e.g., K001, K042, K100)
 * 
 * Features:
 * - Displays knowledge ID with optional title
 * - Click to view details
 * - Uses product accent colors
 * - Square geometry (border-radius: 0)
 */

import { HTMLAttributes } from 'react';

export interface KnowledgeTagProps extends HTMLAttributes<HTMLSpanElement> {
  knowledgeId: string;
  title?: string;
  clickable?: boolean;
}

export function KnowledgeTag({
  knowledgeId,
  title,
  clickable = false,
  className = '',
  ...props
}: KnowledgeTagProps) {
  const Tag = clickable ? 'button' : 'span';
  
  return (
    <Tag
      className={`
        inline-flex items-center gap-1.5
        px-2 py-1
        bg-[var(--reviewer-knowledge-bg)]
        border border-[var(--reviewer-knowledge-border)]
        text-[var(--reviewer-knowledge-text)]
        font-mono text-[var(--reviewer-text-xs)]
        font-medium
        uppercase
        ${clickable ? 'cursor-pointer hover:border-[var(--reviewer-accent)] transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--reviewer-focus-ring)]' : ''}
        ${className}
      `}
      title={title}
      {...props}
    >
      <svg
        className="w-3 h-3"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="square"
          strokeLinejoin="miter"
          strokeWidth={2}
          d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
        />
      </svg>
      {knowledgeId}
    </Tag>
  );
}
